import React from "react";

export default function PlusIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
      <line
        x1="6.5"
        y1="1"
        x2="6.5"
        y2="12"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      ></line>
      <line
        x1="1"
        y1="6.5"
        x2="12"
        y2="6.5"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      ></line>
    </svg>
  );
}
